import * as React from "react";
import { IconProps } from "./types";

export const Umbrella01Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M17 19.4C17 20.8359 15.8807 22 14.5 22C13.1193 22 12 20.8359 12 19.4V12M2.1263 10.4063C2.88951 5.64091 7.01956 2 12 2C16.9804 2 21.1105 5.64091 21.8737 10.4063C21.9482 10.8714 21.9854 11.1039 21.8919 11.3523C21.8175 11.55 21.6353 11.7636 21.4519 11.8684C21.2215 12 20.9476 12 20.4 12H3.6C3.05235 12 2.77853 12 2.54805 11.8684C2.36466 11.7636 2.18249 11.55 2.10808 11.3523C2.01456 11.1039 2.05181 10.8714 2.1263 10.4063Z"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(Umbrella01Icon as React.FunctionComponent).displayName = "Umbrella01Icon";

export default Umbrella01Icon;
